import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {MicroLabel} from '@/components/period-selector'
import {formatShortDate} from '@/lib/risk'

export function TargetDateMeta({
  targetDate,
  previousTargetDate,
  overdue,
}: {
  targetDate: string
  previousTargetDate: string | null
  overdue: boolean
}) {
  const {t} = useTranslation()
  return (
    <div>
      <MicroLabel>{t('plan.meta.targetDate')}</MicroLabel>
      <p className="mt-1 flex flex-wrap items-center gap-1.5">
        <span className="font-mono text-sm">{formatShortDate(targetDate)}</span>
        {overdue && (
          <Tag tone="red" data-testid="overdue-tag">
            {t('plan.overdue')}
          </Tag>
        )}
      </p>
      {previousTargetDate && (
        <p className="mt-0.5 text-xs text-muted-foreground" data-testid="previous-date">
          {t('plan.previousDate', {date: ''})}
          <s className="ml-1 font-mono">{formatShortDate(previousTargetDate)}</s>
        </p>
      )}
    </div>
  )
}
